module.exports = __webpack_public_path__ + "img/icoBonus.152796dc.png";